import { PodcastsListSlider } from "./PodcastsListSlider";

export default PodcastsListSlider;
